const formatter = new Intl.NumberFormat('en-US');
export const formatCreditValue = (num) => num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
export const formatDollarValue = (num) => num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
export const formatTZSValue = (num) => {
    return formatter.format(Number(num.toFixed(0)));
};
//# sourceMappingURL=formatCreditValue.js.map